import { render } from "./CellStory.vue?vue&type=template&id=63707fd3"
import script from "./CellStory.vue?vue&type=script&lang=js"
export * from "./CellStory.vue?vue&type=script&lang=js"

import "./CellStory.vue?vue&type=style&index=0&id=63707fd3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/CellStory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63707fd3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63707fd3', __exports__)) {
    api.reload('63707fd3', __exports__)
  }
  
  module.hot.accept("./CellStory.vue?vue&type=template&id=63707fd3", () => {
    api.rerender('63707fd3', render)
  })

}


export default __exports__